module.exports = __webpack_public_path__ + "img/icon-general-view.6e8cf869.svg";